<owl-carousel-o [options]="optionsDefault">
  <ng-container *ngFor="let mar of carMarca; let i = index">
    <ng-template carouselSlide>
      <a routerLink="../productos" [queryParams]="{marca:mar.fab_codigo}"><img  [src]="mar.img" [alt]="mar.marca" [title]="mar.marca"></a>
    </ng-template>
  </ng-container>
</owl-carousel-o>
